export async function getFile(url: string, filename?: string, includeType?: boolean): Promise<File | null> {
	try {
		const parsedUrl = new URL(url, 'https://dummy.com'); // we just need a base URL to retrieve the pathname
		const result = await fetch(url);
		const blob = await result.blob();

		if (includeType) {
			return new File([blob], filename || parsedUrl.pathname.split('/').pop() || 'file', { type: blob.type });
		}

		return new File([blob], filename || parsedUrl.pathname.split('/').pop() || 'file');
	} catch (e) {
		return null;
	}
}
